import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d7bf320"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-pills" }

import TressNavigationPill from "@/components/TressNavigationPill.vue";
import { PropType } from "vue";
import { ILiveLink } from "@/models/ILiveLink";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressNavigationPills',
  props: {
  links: {
    type: Array as PropType<Array<ILiveLink>>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
      return (_openBlock(), _createBlock(TressNavigationPill, {
        link: link,
        key: link.url
      }, null, 8, ["link"]))
    }), 128))
  ]))
}
}

})